<div class="container-fluid psp-container">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/coupons'"
    [currentPageValue]="'Coupon Details'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="coupon-details-container">
      <div class="card-body">
        <div class="border-bottom title pb-2">
          <h2 class="m-0">Coupon Details</h2>
        </div>

        <div *ngIf="basicDetails" class="basic-details mt-5">
          <h2>Basic Details</h2>
          <div class="card-coupon p-3">
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th *ngFor="let th of basicDetailsTH">
                      {{ th | uppercase }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="pointer">
                    <td>
                      <span>Tests</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.couponName }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.arCouponName }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.couponCode }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.startDate?.split("T")[0] }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.endDate?.split("T")[0] }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.discountPercentage }}</span>
                    </td>
                    <td>
                      <span>{{ basicDetails?.ceiling }}</span>
                    </td>
                    <td>
                      <span>{{
                        basicDetails?.usageTypeId == 1
                          ? "Single Use"
                          : basicDetails?.usageTypeId == 2
                          ? "Once PerCustomer "
                          : "Unlimited"
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="eligibilityCriteria" class="eligibility-criteria mt-5">
          <h2>Eligibility Criteria</h2>
          <div class="card-coupon p-3">
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th *ngFor="let th of eligibilityCriteriaTH">
                      {{ th | uppercase }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr eligibilityCriteriaclass="pointer">
                    <td>
                      <span>{{ eligibilityCriteria?.testType }}</span>
                    </td>
                    <td>
                      <ol *ngIf="eligibilityCriteria?.eligibleTests.length">
                        <li
                          *ngFor="
                            let test of eligibilityCriteria?.eligibleTests
                          "
                        >
                          {{ test }}
                        </li>
                      </ol>
                      <span *ngIf="!eligibilityCriteria?.eligibleTests.length">All</span>
                    </td>
                    <td>
                      <ol *ngIf="eligibilityCriteria?.eligibleLabs.length">
                        <li
                          *ngFor="let lab of eligibilityCriteria?.eligibleLabs"
                        >
                          {{ lab }}
                        </li>
                      </ol>
                      <span *ngIf="!eligibilityCriteria?.eligibleLabs.length">All</span>
                    </td>
                    <td>
                      <ol *ngIf="eligibilityCriteria?.areas.length">
                        <li *ngFor="let area of eligibilityCriteria?.areas">
                          {{ area }}
                        </li>
                      </ol>
                      <span *ngIf="!eligibilityCriteria?.areas.length">All</span>
                    </td>
                    <td>
                      <ol *ngIf="eligibilityCriteria?.branches.length">
                        <li
                          *ngFor="let branche of eligibilityCriteria?.branches"
                        >
                          {{ branche }}
                        </li>
                      </ol>
                      <span *ngIf="!eligibilityCriteria?.branches.length">All</span>
                    </td>
                    <td>
                      <span>{{ eligibilityCriteria?.appliesOn }}</span>
                    </td>
                    <td>
                      <span>{{ eligibilityCriteria?.visitType }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="usageSummary" class="usage-summary mt-5">
          <h2>Usage Summary</h2>
          <div class="card-coupon p-3">
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th colspan="2">Patients</th>
                    <th colspan="3">Transactions</th>
                    <th colspan="2">Labs & Tests</th>
                  </tr>
                  <tr>
                    <th>Total Number of Patients</th>
                    <th>Number of Unique Patients</th>
                    <th>Total Number of Transactions</th>
                    <th>Paid Transactions</th>
                    <th>Unpaid Transactions</th>
                    <th>Total Number of Unique Labs</th>
                    <th>Number of Unique Tests</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="pointer">
                    <td>
                      <span>{{
                        usageSummary.patients.totalNumberOfPatients
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.patients.numberOfUniquePatients
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.transactions.totalNumberOfTransactions
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.transactions.paidTransactions
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.transactions.unpaidTransactions
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.labsAndTests.totalNumberOfUniqueLabs
                      }}</span>
                    </td>
                    <td>
                      <span>{{
                        usageSummary.labsAndTests.numberOfUniqueTests
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="dayByDayDetails?.length" class="usage-summary mt-5">
          <h2>Day By Day Details</h2>
          <div class="card-coupon p-3">
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th *ngFor="let th of dayByDayTH">
                      {{ th | uppercase }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="pointer" *ngFor="let item of dayByDayDetails">
                    <td>
                      <span>{{ item?.date }}</span>
                    </td>
                    <td>
                      <span>{{ item?.numberOfCouponsUsed }}</span>
                    </td>
                    <td>
                      <span>{{ item?.numberOfUniquePatients }}</span>
                    </td>
                    <td>
                      <span>{{ item?.paidTransactions }}</span>
                    </td>
                    <td>
                      <span>{{ item?.unpaidTransactions }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
